import {AxiosInstance} from "axios";

export type ReferralRequestType = 'laboratory' | 'hospital';

export interface ReferralRequest {
    type: ReferralRequestType;
    establishment: string;
    contact_email: string;
    contact_phone: string;
    comment?: string;
}

export default function (client: AxiosInstance) {
    return {
        /**
         * Send a laboratory / hospital referral request.
         *
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async send(request: ReferralRequest): Promise<void> {
            return client.post('/referral-requests', request)
                .then(() => undefined);
        }
    };
}
